import React, { Component } from "react";
import logo from "./img/skyline_logo.png";
import lightLogo from "./img/skyline_logo_transparent.png";
import intl from "react-intl-universal";
import { Link, NavLink } from "react-router-dom";
import AccountStatus from "./components/accountStatus";
import "./dashcore/html/css/aos.css";
import "./dashcore/html/css/bootstrap.css";
import "./dashcore/html/css/cookieconsent.min.css";
import "./dashcore/html/css/fontawesome-all.css";
import "./dashcore/html/css/helper.css";
import "./dashcore/html/css/magnific-popup.css";
import "./dashcore/html/css/odometer-theme-minimal.css";
import "./dashcore/html/css/pe-icon-7-stroke.css";
import "./dashcore/html/css/prettify.css";
import "./dashcore/html/css/simplebar.css";
import "./dashcore/html/css/smart_wizard.css";
import "./dashcore/html/css/smart_wizard_theme_arrows.css";
import "./dashcore/html/css/smart_wizard_theme_circles.css";
import "./dashcore/html/css/smart_wizard_theme_dots.css";
import "./dashcore/html/css/demo.css";
import "./dashcore/html/css/swiper.css";
import "./dashcore/html/css/styles.css";

class Header extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const isNavHeader = () => {
      return !window.location.pathname.toLowerCase().includes("/account") && window.location.pathname !== "/" ?  "navHeader" : "";
    }
    return (
      <nav className={this.props.classNavBarName + " " + isNavHeader()}>
        <div className="container">
          
          {!window.location.pathname.toLowerCase().includes("/account") && window.location.pathname !== "/" ?
              this.props.isSubLoginType ? 
                <img
                  className="customer-img-responsive"
                  src={this.props.customerLogoUrl}
                  alt="logo"
                />
              : 
              <a className="navbar-brand" href="https://www.skylinesoft.com">
                <img
                  className="img-responsive"
                  src={this.props.navLogo === "lightLogo" ? lightLogo : logo}
                  alt="logo"
                />
              </a>
             : null
          }
          {this.props.isSubLoginType ? 
            null 
          : 
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNavAltMarkup"
              aria-controls="navbarNavAltMarkup"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
          }
          
          {this.props.isSubLoginType ? 
            null 
          : 
            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
              <ul className="navbar-nav mr-auto navbarTitles">
                {/* <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to="/atlasUs/Overview"
                    // activeClassName="active"
                  >
                    {intl.get("Nav_Bar_Atlas_Us")}
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to="/atlasUs/pricing"
                    activeClassName="active"
                  >
                    {intl.get("Nav_Bar_Princing")}
                  </NavLink>
                </li> */}
              </ul>
              <AccountStatus
                isLoggedIn={this.props.isLoggedIn}
                onClick={this.props.onClick}
                userHasAuthenticated={this.props.userHasAuthenticated}
                handleServerError={this.props.handleServerError}
                firstName={this.props.firstName}
                lastName={this.props.lastName}
                userName={this.props.userName}
                props={this.props.props}
              />
            </div>
          }
        </div>
      </nav>
    );
  }
}

export default Header;
